import getWafToken from './wafToken';

interface ContactUsEventBody {
  name: string;
  email: string;
  phoneNumber: string;
  message: string;
}

const openApi: string = import.meta.env.VITE_PLATFORM_API ?? '';

const buildHeaders = async (): Promise<Record<string, string>> => {
  const headers: Record<string, string> = { 'Content-Type': 'application/json' };
  const wafToken = await getWafToken();
  if (wafToken) {
    headers['x-aws-waf-token'] = wafToken;
  }
  return headers;
};

export const ContactUs = async (request: ContactUsEventBody) => {
  const response = await fetch(openApi + '/contact-us', {
    method: 'POST',
    headers: await buildHeaders(),
    body: JSON.stringify(request),
  }).then((data) => {
    if (data.ok && data.status === 200) {
      return data.json();
    } else {
      throw 'non 2xx response';
    }
  });

  return response;
};

export interface AskAssistantRequestBody {
  question: string;
  userId: string;
  sessionId: string;
}

export interface AskAssistantResponse {
  answer: string;
}

// 503 is the backend's deliberate "assistant busy / throttled" signal
// (distinct copy in the chat UI); every other failure is generic.
export class AssistantBusyError extends Error {
  constructor() {
    super('assistant busy');
    this.name = 'AssistantBusyError';
  }
}

export const AskAssistant = async (
  request: AskAssistantRequestBody,
): Promise<AskAssistantResponse> => {
  const response = await fetch(openApi + '/api/assistant/ask', {
    method: 'POST',
    headers: await buildHeaders(),
    body: JSON.stringify(request),
  });
  if (response.status === 503) {
    throw new AssistantBusyError();
  }
  if (!response.ok) {
    throw new Error('non 2xx response');
  }
  return (await response.json()) as AskAssistantResponse;
};
